import * as React from "react";
const SvgPencil = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m15.748 1.564-6.937 6.94-6.94 6.937v6.686H8.56l6.937-6.938 6.94-6.937-3.344-3.344zm0 2.122 2.283 2.283 2.283 2.283-1.109 1.107-1.11 1.11-2.28-2.283-2.284-2.282 1.11-1.11zm-3.277 3.283c.002 0 1.03 1.027 2.285 2.281l2.28 2.28-4.546 4.544-4.547 4.547H3.38v-4.564l4.543-4.543c2.499-2.5 4.546-4.545 4.549-4.545Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgPencil;
